export function getGoAccountsApiURL(): string {
	if (process.env.REACT_APP_GOACCOUNTS_URL) {
		return process.env.REACT_APP_GOACCOUNTS_URL;
	}
	return "http://app.goaccounts.local";
}

export function getApiURL(): string {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}
	return "http://app.gopos.local";
}

export function getTokenClientId(): string {
	if (process.env.REACT_APP_CLIENT_ID) {
		return process.env.REACT_APP_CLIENT_ID;
	}

	return "16a056f6-b6f6-45f1-bd22-4561df5bc7c6";
}

export function getTokenClientSecret(): string {
	if (process.env.REACT_APP_CLIENT_SECRET) {
		return process.env.REACT_APP_CLIENT_SECRET;
	}

	return "aab7ad66-c79d-11eb-b8bc-0242ac130003";
}

export function getSentryDSN() {
	if (process.env.REACT_APP_SENTRY_DSN) {
		return process.env.REACT_APP_SENTRY_DSN;
	}

	return "";
}

export function getGoogleAnalyticsId(): string | undefined {
	if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
		return process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
	}
	return undefined;
}

export function getNotificationTemplate(): string | undefined {
	if (process.env.REACT_APP_NOTIFICATION_TEMPLATE) {
		return process.env.REACT_APP_NOTIFICATION_TEMPLATE;
	}
	return undefined;
}

export function getCreatingDeliveryZones(): string | undefined {
	if (process.env.REACT_APP_CREATING_DELIVERY_ZONES) {
		return process.env.REACT_APP_CREATING_DELIVERY_ZONES;
	}
	return undefined;
}

export function getSubscriptionBasedRestrictions(): string | undefined {
	if (process.env.REACT_APP_SUBSCRIPTION_BASED_RESTRICTIONS) {
		return process.env.REACT_APP_SUBSCRIPTION_BASED_RESTRICTIONS;
	}
	return undefined;
}

export function employeeTipsEnabled(): string | undefined {
	if (process.env.REACT_APP_EMPLOYEE_TIPS) {
		return process.env.REACT_APP_EMPLOYEE_TIPS;
	}
	return undefined;
}

export function terminalsUpgradeEnabled(): string | undefined {
	if (process.env.REACT_APP_TERMINALS_UPGRADE) {
		return process.env.REACT_APP_TERMINALS_UPGRADE;
	}
	return undefined;
}

export function paymentEnvironment(): google.payments.api.Environment {
	return (process.env?.REACT_APP_PAYMENT_ENVIRONMENT as google.payments.api.Environment) ?? "TEST";
}

export function gatewayMerchantId(): string {
	return process.env?.REACT_APP_GATEWAY_MERCHANT_ID ?? "";
}

export function googlePayEnvironment(): string | undefined {
	return process.env?.REACT_APP_GOOGLE_PAY_ENVIRONMENT;
}

export function areUpsellsEnabled(): boolean {
	return process.env?.REACT_APP_UPSELLS_ENABLED === "true";
}
